module.exports = __webpack_public_path__ + "img/slider_portatil.ccbfaf29.jpg";